import { render, staticRenderFns } from "./intervention_dosage_edit.vue?vue&type=template&id=f031fc42&scoped=true&"
import script from "./intervention_dosage_edit.vue?vue&type=script&lang=js&"
export * from "./intervention_dosage_edit.vue?vue&type=script&lang=js&"
import style0 from "./intervention_dosage_edit.vue?vue&type=style&index=0&id=f031fc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f031fc42",
  null
  
)

export default component.exports